/**
 * ERP dev-login links (Godlike ERP #1419 / #1420).
 *
 * The ERP hands its agents a one-time link `{dev_url}/dl?t=<token>`. The /dl page
 * redeems the token at the server (POST {apiUrl}/dev-login/, InvestimeServer #1420)
 * and signs in with the returned JWT pair. The route exists only in the dev build.
 *
 * The redeem call deliberately uses plain axios, not the services/api instance: a
 * 401 there would run the refresh interceptor and end the session with a redirect
 * to /auth/login?session=expired, which is exactly the symptom this page fixes.
 * The token is never logged.
 */
import axios from "axios";

import config from "services/config";

export const DEV_LOGIN_PATH = "/dl";

export const isDevLoginEnabled = (env) => env === "dev";

export const readDevLoginToken = (search) => {
  const token = new URLSearchParams(search || "").get("t");
  return token ? token : null;
};

export const redeemDevLoginToken = (token) =>
  axios.post(`${config.apiUrl}/dev-login/`, { t: token });

// Fallback texts when the server gives no `detail` (the server's own texts win).
const MESSAGES_BY_CODE = {
  bad_token: "Linkki ei kelpaa.",
  expired: "Linkki on vanhentunut.",
  used: "Linkki on jo käytetty.",
  missing_token: "Linkki ei kelpaa.",
  not_found: "Dev-kirjautuminen ei ole käytössä tässä ympäristössä.",
};

export const NETWORK_ERROR_MESSAGE = "Dev-kirjautumispalvelu ei vastaa";

/** -> { message, code } for an error from redeemDevLoginToken. */
export const devLoginErrorMessage = (err) => {
  const response = err && err.response;
  if (!response) {
    return { message: NETWORK_ERROR_MESSAGE, code: "network_error" };
  }
  const data = response.data && typeof response.data === "object" ? response.data : {};
  const code = data.code
    ? String(data.code)
    : response.status === 404
      ? "not_found"
      : `http_${response.status}`;
  const message = data.detail
    ? String(data.detail)
    : MESSAGES_BY_CODE[code] || `Dev-kirjautuminen epäonnistui (HTTP ${response.status}).`;
  return { message, code };
};
